import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "AI";

const parseApiError = (error, defaultMessage) => {
  // status pode ser undefined em erro de rede/cors/timeout
  validateRequestErrorStatus(error?.response?.status);

  const data = error?.response?.data || {};
  const message = data?.message || defaultMessage;
  const errors = data?.errors || [];

  return { message, errors };
};

// GET /api/v1/AI/Conversas?skip=0&take=20
export const ListarConversasAIChat = (skip = 0, take = 20) =>
  RequestWebApi.get(`/${controller}/Conversas`, {
    params: { skip, take }
  })
    .then((response) => {
      const { success, resultData, total, message, errors } = response.data || {};

      return {
        success: !!success,
        conversas: resultData ?? [],
        total: total ?? 0,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao listar conversas do AIChat.");

      return {
        success: false,
        message,
        errors,
        conversas: [],
        total: 0
      };
    });


// GET /api/v1/AI/Conversas/{chatConversaId}/Mensagens?take=50&before=...
export const ListarMensagensConversaAIChat = (chatConversaId, take = 50, before = null) => {
  if (!chatConversaId) {
    return Promise.resolve({
      success: false,
      message: "chatConversaId não informado.",
      errors: [],
      mensagens: []
    });
  }

  const params = { take };
  if (before) params.before = before;

  return RequestWebApi.get(`/${controller}/Conversas/${chatConversaId}/Mensagens`, { params })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        mensagens: resultData ?? [],
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao listar mensagens da conversa.");

      return {
        success: false,
        message,
        errors,
        mensagens: []
      };
    });
};


// POST /api/v1/AI/EnviarMensagem
// body: { conversationId, messageId, text, rawPayload? }
export const EnviarMensagemAIChat = (conversationId, messageId, text, rawPayload = null) => {
  if (!conversationId) {
    return Promise.resolve({
      success: false,
      message: "conversationId não informado.",
      errors: [],
      data: null
    });
  }

  if (!messageId) {
    return Promise.resolve({
      success: false,
      message: "messageId não informado.",
      errors: [],
      data: null
    });
  }

  if (!text || !text.trim()) {
    return Promise.resolve({
      success: false,
      message: "text não informado.",
      errors: [],
      data: null
    });
  }

  return RequestWebApi.post(`/${controller}/EnviarMensagem`, {
    conversationId,
    messageId,
    text,
    rawPayload
  })
    .then((response) => {
      const { success, data, message, errors } = response.data || {};

      return {
        success: !!success,
        data: data ?? null, // { conversationId, messageId, replyText, serverTime }
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao enviar mensagem para o AIChat.");

      return {
        success: false,
        message,
        errors,
        data: null
      };
    });
};
